/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Please set only if you want to update the evidence information at the time of draft registration. If you want the uploaded file to be treated as an invoice, be sure to set the `invoiceEvidenceId`.
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'electronicMethod'?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'documentSize'?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'invoiceIssuerRegistrationNumber': string | null;
}

export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum];
export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum];


